"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SiteLinks = void 0;
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../hooks");
var _Accordion = require("./components/Accordion");
var _Group = require("./components/Group");
var _Links = require("./components/Links");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SiteLinks = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    siteLinksColumns
  } = (0, _hooks.useFooter)();
  const isMobile = (0, _presentationHooks.useIsMobile)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_constants.SITE_LINKS),
    children: isMobile ? siteLinksColumns.map(({
      title,
      children
    }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Accordion.Accordion, {
      header: title,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Links.Links, {
        items: children
      })
    }, title)) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Inner, {
      children: siteLinksColumns.map(({
        title,
        children
      }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Group.Group, {
        header: title,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Links.Links, {
          items: children
        })
      }, title))
    })
  });
};
exports.SiteLinks = SiteLinks;
